export const stats: [string, string][] = [
  ['10', 'COMPLETE VOLUMES'],
  ['600+', 'READY-TO-USE PAGES'],
  ['180', 'STRUCTURED ACTIVITIES'],
  ['K–12', 'ELEMENTARY + SECONDARY'],
]
